<template>
  <div>
    <!-- -->
    <ul class="stepsUl">
      <li
        class="stepItem"
        :class="{'active':stepIdx==1}"
      >
        <strong class="bigNum">1</strong>
        <div class="rightMain">
          <img
            v-if="stepIdx==1"
            src="https://ipchain.oss-cn-hangzhou.aliyuncs.com/web/privateicon/stepIcon1.svg"
          >
          <img
            v-else
            class="stepdone" src="https://ipchain.oss-cn-hangzhou.aliyuncs.com/web/privateicon/stepIcon1.svg"
          >
          <div class="tittle">版权存证</div>
          <div class="desc">区块链存证，直通互联网法院</div>
        </div>
      </li>
      <li>
       <img
          class="arrow"
           src="https://ipchain.oss-cn-hangzhou.aliyuncs.com/web/privateicon/arrow.svg"
          >
      </li>
     <!-- <li
        class="stepItem"
        :class="{'active':stepIdx==2}"
      >
        <strong class="bigNum">2</strong>
        <div class="rightMain">
          <img
            v-if="stepIdx==2"
            src="https://ipchain.oss-cn-hangzhou.aliyuncs.com/web/privateicon/stepIcon2.svg"
          >
          <img
            v-else
            class="stepdone" src="https://ipchain.oss-cn-hangzhou.aliyuncs.com/web/privateicon/stepIcon2.svg"
          >
          <div class="tittle">版权登记</div>
          <div class="desc">版权官方登记证书</div>
        </div>
      </li>
       <li>
       <img
        class="arrow"
           src="https://ipchain.oss-cn-hangzhou.aliyuncs.com/web/privateicon/arrow.svg"
          >
      </li> -->
     <li
        class="stepItem"
        :class="{'active':stepIdx==3}"
      >
        <strong class="bigNum">2</strong>
        <div class="rightMain">
          <img
            v-if="stepIdx==3"
            src="https://ipchain.oss-cn-hangzhou.aliyuncs.com/web/privateicon/stepIcon3.svg"
          >
          <img
            v-else
            class="stepdone
" src="https://ipchain.oss-cn-hangzhou.aliyuncs.com/web/privateicon/stepIcon3.svg"
          >
          <div class="tittle">版权监测</div>
          <div class="desc">作品在线监测，全网搜查</div>
        </div>
      </li>
       <li>
        <img
         class="arrow"
           src="https://ipchain.oss-cn-hangzhou.aliyuncs.com/web/privateicon/arrow.svg"
          >
      </li>
     <li
        class="stepItem"
        :class="{'active':stepIdx==4}"
      >
        <strong class="bigNum">3</strong>
        <div class="rightMain">
          <img
            v-if="stepIdx==4"
            src="https://ipchain.oss-cn-hangzhou.aliyuncs.com/web/privateicon/stepIcon4.svg"
          >
          <img
            v-else
            class="stepdone" src="https://ipchain.oss-cn-hangzhou.aliyuncs.com/web/privateicon/stepIcon4.svg"
          >
          <div class="tittle">版权取证</div>
          <div class="desc">区块链上链记录，浏览器可查</div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Steps',
  props: {
    // 是否为VIP主页
    stepIdx: {
      type: [Number, String],
      default: 1
    }
  },
  data () {
    return {
    }
  },

  methods: {}
}
</script>

<style lang='scss' scoped>
.stepsUl {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin:24px 0;
  li {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .arrow{
    position: relative;
    left: -40px;
  }
  .stepItem {
    justify-content: flex-start;
    align-items: flex-start;
    color: rgba(0, 18, 22, 0.65);
    width:218px;
    .bigNum {
      font-size: 64px;
      font-weight: bolder;
      line-height: 1em;
      margin-top: 5px;
      color:rgba(0, 18, 22,.2);
      transform: scaleX(.95)  skewX(-12deg);
    }
    .rightMain {
      flex: 1;
      img {
        width: 72px;
      }
      .tittle {
        font-size: 18px;
        font-weight: bold;
        margin-top: -4px;
      }
      .desc {
        color: rgba(0, 18, 22, 0.45);
        margin-top: 4px;
      }
      .stepdone{opacity: 0.5;}
    }
  }
  .active {
    color: rgba(0, 18, 22, 0.85);
    .bigNum {
      color: #007DFF;
    }
    .desc {
      color: rgba(0, 18, 22, 0.65);
    }
  }
}
@media (max-width: 576px) {
  .stepsUl {
     flex-wrap: wrap;
  }
}
</style>
